import React, { useState, useEffect } from 'react';
import { LOOTBOX_RARITIES } from '../../constants/lootbox';
import ItemIcon from './ItemIcon';

const LOOTBOX_CENTER_INDEX = 50;

function buildStrip(items, lootboxType, wonItem) {
  let availableItems = items;
  if (lootboxType === 'elite' || lootboxType === 'god') {
    availableItems = items.filter(item =>
      item.rarity === 'EPIC' ||
      item.rarity === 'LEGENDARY' ||
      item.rarity === 'MYTHIC' ||
      item.rarity === 'GALAXY' ||
      item.rarity === 'NUCLEAR'
    );
  }
  const strip = Array.from({ length: 100 }, () =>
    availableItems[Math.floor(Math.random() * availableItems.length)]
  );
  // Place the won item at the center so the animation always lands on it
  if (wonItem) {
    strip[LOOTBOX_CENTER_INDEX] = wonItem;
  }
  return strip;
}

function LootboxAnimation({ items, wonItem, lootboxType }) {
  const [displayItems, setDisplayItems] = useState(() => buildStrip(items, lootboxType, wonItem));
  // Offset capped to ±40px so the indicator stays within the center item
  // even on mobile where items are only 100px wide (half = 50px > 40px).
  const [randomOffset] = useState(() => Math.random() * 80 - 40);

  // When the server result arrives mid-animation, slot it into position 50.
  // The strip is still scrolling so this position is off-screen — no visible swap.
  useEffect(() => {
    if (wonItem) {
      setDisplayItems(prev => {
        const updated = [...prev];
        updated[LOOTBOX_CENTER_INDEX] = wonItem;
        return updated;
      });
    }
  }, [wonItem]);

  return (
    <div className="lootbox-animation-container">
      <div className="lootbox-window">
        <div className="lootbox-indicator"></div>
        <div
          className="lootbox-strip"
          style={{
            '--random-offset': `${randomOffset}px`
          }}
        >
          {displayItems.map((item, index) => {
            const rarity = LOOTBOX_RARITIES[item.rarity];
            return (
              <div
                key={index}
                className={`lootbox-item ${rarity.glow ? 'glow' : ''}`}
                style={{
                  borderColor: rarity.color,
                  boxShadow: rarity.glow ? `0 0 20px ${rarity.color}` : 'none'
                }}
              >
                <div className="item-icon"><ItemIcon item={item} size={48} /></div>
                <div className={`item-name ${rarity.rainbow ? 'rainbow-glow' : ''}`} style={{ color: rarity.color }}>
                  {item.name}
                </div>
                <div className={`item-rarity ${rarity.rainbow ? 'rainbow-glow' : ''}`} style={{ color: rarity.color }}>
                  {rarity.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="lootbox-animation-text">Opening...</div>
    </div>
  );
}

export default LootboxAnimation;
